import { Injectable } from '@angular/core';
import { AngularFire } from 'angularfire2';
import { Event, Page } from '../models';
import 'rxjs/add/operator/map';
import { FirebaseService } from './firebase.service';

@Injectable()
export class CalendarService extends FirebaseService {
  events: Event[] = [];

  constructor(protected _af: AngularFire) {
    super();
    this.firebaseType = 'events';
  }

  mapObjJson(jsonEvents: any, eventUrl?: string): Event[] {
    let events = jsonEvents.map((event) => new Event(event));
    this.events.length = 0;
    [].push.apply(this.events, events);
    this.updateEventsWithPages();

    return this.events;
  }

  getEventByUrl(firebaseUrl: string) {
    return this._af.database.object(this.firebaseRoot + '/events/' + firebaseUrl)
    .map(jsonEvent => {
      jsonEvent.firebaseUrl = firebaseUrl;
      let event = new Event(jsonEvent);
      this.updateEventWithPage(event);
      return event;
    });
  }

  getEventObjectByUrl(firebaseUrl: string) {
    let events = this.events.slice();
    for (let i = 0; i < events.length; i++) {
      if (events[i].firebaseUrl === firebaseUrl) return events[i];
    }
  }

  saveEvents(events: Event[]) {
    let eventsJson = events.map(event => event.toFirebaseObject());
    return this._af.database.object(this.firebaseRoot).update({ events: eventsJson });
  }

  // Called when pages or events are updated
  updateEventsWithPages(pages?: Page[]) {
    if (!pages) pages = this.pages;
    this.pages = pages;
    this.events.forEach(event => {
      this.updateEventWithPage(event);
    });
  }

  updateEventWithPage(event: Event) {
    let page = this.pages.filter(page => page.id === event.targetID);
    if (page.length) event.targetPage = page[0];
    else event.targetPage = null;
  }

  updateEventsWithDeletedPage(deletedPage: Page) {
    let events = this.events.slice();
    let firebaseList = [];

    events.forEach(event => {
      if (event.targetID && event.targetID.toString() === deletedPage.id) {
        event.targetPage = null;
        event.targetID = null;
      }
      firebaseList.push(event.toFirebaseObject());
    });

    return this._af.database.object(this.firebaseRoot).update({ 'events' : firebaseList });
  }

  sortAscending(events: Event[]): Event[] {
    let newArray = events.slice().sort(function (a, b) {
      let firstStart = new Date(a.startDateTime);
      let secondStart = new Date(b.startDateTime);
      return firstStart < secondStart ? -1 : firstStart > secondStart ? 1 : 0;
    });
    return newArray;
  }

  sortDescending(events: Event[]): Event[] {
    let newArray = events.slice().sort(function (a, b) {
      let firstStart = new Date(a.startDateTime);
      let secondStart = new Date(b.startDateTime);
      return firstStart > secondStart ? -1 : firstStart < secondStart ? 1 : 0;
    });
    return newArray;
  }

  getOldEvents(events: Event[]) : { monthYear: Date, events: Event[] }[] {
    let eventsMap: { monthYear: Date, events: Event[] }[] = [];
    let currentDate = new Date();

    if (events && events.length) {
      let sortedEvents = this.sortAscending(events);
      for (let i = 0; i < sortedEvents.length; i++) {
        let event = sortedEvents[i];
        let eventDate = new Date(event.startDateTime);
        if (eventDate >= currentDate) break;
        let monthYear = new Date(eventDate.getFullYear(), eventDate.getMonth());
        if (!eventsMap.length || eventsMap[eventsMap.length - 1].monthYear.getTime() !== monthYear.getTime()) {
          eventsMap.push({ monthYear: monthYear, events: [event] });
        } else {
          eventsMap[eventsMap.length - 1].events.push(event);
        }
      };
    }

    return eventsMap;
  }

  getFutureEvents(events: Event[]) : { monthYear: Date, events: Event[] }[] {
    let eventsMap: { monthYear: Date, events: Event[] }[] = [];
    let currentDate = new Date();

    if (events && events.length) {
      let sortedEvents = this.sortAscending(events);
      for (let i = 0; i < sortedEvents.length; i++) {
        let event = sortedEvents[i];
        let eventDate = new Date(event.startDateTime);
        if (eventDate < currentDate) continue;

        let monthYear = new Date(eventDate.getFullYear(), eventDate.getMonth());
        if (!eventsMap.length || eventsMap[eventsMap.length - 1].monthYear.getTime() !== monthYear.getTime()) {
          eventsMap.push({ monthYear: monthYear, events: [event] });
        } else {
          eventsMap[eventsMap.length - 1].events.push(event);
        }
      };
    }

    return eventsMap;
  }
}



// WEBPACK FOOTER //
// /app/src/app/shared/services/app/content/helpers/event.service.ts